<template>
  <div class="publishNews">
    <el-form ref="form" :model="form" :label-position="'top'" label-width="150px" width="500px">
        <el-form-item label="Nhập tiêu đề:">
            <el-input v-model="title"></el-input>
        </el-form-item>
        <el-form-item label="Nhập nội dung:">
        <vue-editor v-model="content"></vue-editor>
        </el-form-item>
        <el-button type="primary" @click="onSubmit">submit</el-button>
    </el-form>
  </div>
</template>
<script>
import { VueEditor } from "vue2-editor";
export default {
    data() {
      return {
          title:"",
          content:""
      }
    },
    components:{VueEditor},
    methods: {
      onSubmit() {
          const that=this;
          if(this.title==""){
              this.$message({message:"title is empty",type: 'error'})
              return ;
          }
          if(this.content==""){
              this.$message({message:"the news content is empty",type: 'error'})
              return ;
          }
        this.$alert('Bài viết đã được gửi và sẽ được duyệt trong vòng 24h', 'Gửi bài thành công', {
          confirmButtonText: 'OK',
          callback: () => {
            that.$router.push({ path: "/" });
          }
        });
      }
    }
}
</script>
<style scoped>
.publishNews {
  display: block;
  position: relative;
  width: 1000px;
  margin: 0 auto;
  text-align: center;
  font-size: 24px;
  color: #f72442;
  padding: 45px 0 32px;
}
form{text-align: left;}
</style>




// WEBPACK FOOTER //
// PublishNews.vue?63da6592